import useSWR from 'swr';
import { fetcher } from '@shared/fetcher';
import { StoreSchema, IStore } from '@shared/types.ts';
import { StoreListItemProps } from '@ui/store/stores-list';

async function fetchStores(url: string) {
  const res = await fetcher.get<{ data: IStore[] }>(url).catch(() => null);
  if (!res) return undefined;
  return res.data?.data.filter((i) => StoreSchema.isValidSync(i));
}

export function useProductsStores({ productId }: { productId: number }) {
  const { data } = useSWR(
    `/api/pharmacies?city_id=${1}&product_ids[0]=${productId}`,
    fetchStores
  );

  const mapped = data?.map<StoreListItemProps | undefined>((storeItem) => {
    return {
      title: storeItem.address,
      isLoading: false,
      statuses: [{ variant: 'open' }, { variant: 'available' }],
      timesheet: `${storeItem.working_from} - ${storeItem.working_to}`,
    };
  });

  const array = Array(10)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: mapped || array,
  };
}
